import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Rewards from './rewards';
import BalancesView from '@/common/customer-balances/BalancesView';

const { Customer } = Mobi2Go;

const LoyaltyModal = ({ closeModal }) => {
    const [t] = useTranslation('order.loyalty');
    const [loyalty, setLoyalty] = useState({});

    useEffect(() => {
        const updateState = () => {
            setLoyalty(
                Customer.isLoggedIn()
                    ? Customer.getLoyalty('SpoonityLoyalty')
                    : null
            );
        };
        Customer.bind({
            updateLoyalty: updateState,
        });
        updateState();
        return () => {
            Customer.unbind({
                updateLoyalty: updateState,
            });
        };
    }, []);

    return (
        <>
            {loyalty?.program?.settings?.authentication_enabled &&
                !loyalty?.state?.is_profile_verified && (
                    <div className="m2g-customer-verification__container">
                        <p className="m2g-customer-verification__text">
                            {t('verify_account')}
                        </p>
                    </div>
                )}

            <BalancesView />
            <Rewards closeModal={closeModal} />
        </>
    );
};

export default LoyaltyModal;
